import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router';
import { useAuth } from 'providers/AuthProvider';
import { getHomePath } from 'utils/auth';

/**
 * GuestGuard - Prevents authenticated users from accessing auth pages (login, signup)
 */
const GuestGuard = ({ children }: PropsWithChildren) => {
  const { sessionUser } = useAuth();

  if (!sessionUser) return children;

  // Redirect authenticated users to their appropriate home page
  return <Navigate to={getHomePath(sessionUser)} replace />;
};

export default GuestGuard;
